<script>
const { required, requiredIf } = require('vuelidate/lib/validators');

export default {
  name: 'BmiCalculator',
  data() {
    return {
      isMetric: true,
      bmi: null,
      // metric system
      centimeters: '',
      kilograms: '',
      // imperial system
      feet: '',
      inches: '',
      pounds: '',
    };
  },
  validations() {
    if (this.isMetric) {
      return {
        centimeters: { required },
        kilograms: { required },
      };
    }

    return {
      feet: { required: requiredIf(() => !this.inches) },
      inches: { required: requiredIf(() => !this.feet) },
      pounds: { required },
    };
  },
  computed: {
    color() {
      if (this.bmi < 18.5) {
        return '#ffd91b';
      } if (this.bmi >= 18.5 && this.bmi < 24.9) {
        return '#5dbd00';
      } if (this.bmi >= 24.9 && this.bmi < 29.9) {
        return '#ffd91b';
      } if (this.bmi > 29.9) {
        return '#f37421';
      }
      return null;
    },
    formatedBmi() {
      return this.bmi.toFixed(1);
    },
  },
  methods: {
    calculate() {
      const kilograms = this.isMetric ? Number(this.kilograms) : Number(this.pounds) / 2.205;
      const meters = this.isMetric
        ? Number(this.centimeters) / 100
        : (Number(this.feet) * 12 + Number(this.inches)) / 39.37;

      // BMI = kg/m2
      this.bmi = kilograms && meters ? kilograms / (meters ** 2) : null;
    },
    preventNonNumeric(event) {
      // prevent '.' if there is already a '.' or '.' would be the first character
      if (event.key === '.' && (event.target.value.includes('.') || event.target.value === '')) {
        event.preventDefault();
      }

      // prevent anything not numeric
      if (!['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '.'].includes(event.key)) {
        event.preventDefault();
      }
    },
    reset() {
      this.bmi = null;
    },
    submit() {
      this.$v.$touch();
      this.calculate();
    },
    toggleSystem() {
      this.isMetric = !this.isMetric;
      this.reset();
    },
  },
};
</script>
